export default __webpack_public_path__ + "static/media/rocket_anim_52.e1c05989.png";